import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ClaimsHeaderService } from "../../shared/claimsHeader/claims-header.service";
import { ApiRequest, IAddUpdateBulkEmployeeRequestDto, IApiRequest, IApiresponse, IGetAllEmployeesRequest } from "../../_models";
import {
    GetFormFieldDetailRequest, GetFormRequest, GetPoDisplayRequest,
    GetPoTemplatePropertiesRequest, GetRequisitionUserListRequest,
    GetRequisitionUserListResponse, IAddUpdateBulkVendorRequestDto,
    IFormsUpdateRequest, ISaveRequestWithFile, IReqSaveVendorSettings,
    IResponseVendorSettings, PoDisplayResponse, PoTemplatePropertiesResponse,
    ReqIncompleteClaimantList, ReqSaveVendorForms, RespForms, RespGetKYCDocumentsForApproval,
    RespIncompleteMileageList, RespMasterFormFields, ResponseVendorKYCDocuments, RespVendorDashboardDetails,
    SavePoDisplayRequest, SavePoTemplatePropertiesRequest, UpdateForRequisitionRequest,
    UpdateForRequisitionResponse, UserKYCFormFieldDetailRequest, UserKYCFormFieldDetailResponse,
    VendorListResponse, GetGradeMappingRequest, RespGetItemGradeMapping, RequestSaveCategoriesAndItemsData,
    RequestImportVendorGrades, GetVendorListRequest,
    GetOrderListRequest,
    RespGetOrderData,
    GetCategoryListResponse,
    GradeMappringResponse,
    RespGradeAssignUnassignToItem,
    SaveOrderDetailReq,
    SaveOrderDetailResponse,
    ApproveRejectRequisitionRequest,
    AddUpdatePOandMappingReq,
    AddUpdatePOandMappingResp,
    GetPOandMappingDataReq,
    GetPOandMappingDataResp,
    GetPoPreviewRequest,
    PoExportRequest,
    IGetAndSaveItemBrandsReqResp,
    SaveItemGradeMappingRequest,
    GetInvoiceDataReq,
    GetInvoiceDataResp,
    GetReportPODetailsReq,
    GetReportPODetailsResp,
    GetVendorInvoiceListReq,
    GetVendorInvoiceListResp,
    SubmitInvoiceActionRequest,
    SubmitInvoiceActionResponse,
    GetPoItemsPassbookRequest,
    AddUpdateOrderAllocationRequest,
    GetItemOrderAllocationRequest,
    ReqGetVendorDashboard,
    GetVendorDashboardDetailsResponse,
    GetDashboardReportRequest,
    GetDashboardReportResponse
} from "../../_models/vendor/vendor.model";
import { GetOrgPreferencesRequest, ITwoStepApprovalSaveRequest, ITwoStepApprovalSaveResponse } from "src/app/_models/twostepapproval/twostepapproval";
import { DeleteCategoryItem } from "src/app/_models/manage-category/manage-category-list-response";
import { GradeCsvRecordExport, IGradeCsvRecordExport, IRequestGrade, IRequestGradeBulkDeactivate, IRequestGradeListAll, IRequestGradeListForAssignEmployee, IResponseGradeList, IVendorGradeCsvRecord, IVendorGradeCsvRecordExport, VendorGradeCsvRecord, VendorGradeCsvRecordExport } from "../../_models/grade/grade";
import { ExcelExportService } from "../common/excel-export.service";
import { saveAs } from 'file-saver';
import { ClaimsService } from '../common/claims.service';
import { Claims } from '../../_models/common/claims';
@Injectable({
    providedIn: 'root'
})
export class VendorService {
    claims: Claims;
    constructor(private http: HttpClient, private claimsHeaderService: ClaimsHeaderService,
        private excelExportService: ExcelExportService, public claimsService: ClaimsService) {
        this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
        });
    }
    GetVendorSettings(): Observable<IApiresponse<IResponseVendorSettings>> {
        return this.http.get<IApiresponse<IResponseVendorSettings>>(
            `${environment.billingApiUrl}GetVendorSettings`,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    SaveVendorSettings(requestinfo: IApiRequest<IReqSaveVendorSettings>): Observable<IApiresponse<boolean>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<boolean>>(`${environment.billingApiUrl}SaveVendorSettings`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetMasterFormFields(): Observable<IApiresponse<RespMasterFormFields>> {
        return this.http.get<IApiresponse<RespMasterFormFields>>(
            `${environment.apAutomationUrl}GetMasterFormFields`,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    GetForms(requestinfo: IApiRequest<GetFormRequest>): Observable<IApiresponse<RespForms>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<RespForms>>(`${environment.apAutomationUrl}GetForms`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetVendorKYCDocuments(): Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        return this.http.get<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}GetVendorKYCDocuments`,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    SaveVendorForms(requestinfo: IApiRequest<ReqSaveVendorForms>): Observable<IApiresponse<boolean>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<boolean>>(`${environment.apAutomationUrl}SaveVendorForms`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    SaveDefaultForms(requestinfo: IApiRequest<ReqSaveVendorForms>): Observable<IApiresponse<boolean>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<boolean>>(`${environment.apAutomationUrl}SaveDefaultForms`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    SaveFormDetails(requestInfo: IApiRequest<ISaveRequestWithFile>):
        Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        let formData = new FormData();
        for (let index = 0; index < requestInfo.requestInfo.documents.length; index++) {
            formData.append('documents', requestInfo.requestInfo.documents[index]);
        }
        formData.append('requestData', requestInfo.requestInfo.requestData);
        formData.append('content', requestInfo.requestInfo.content);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}SaveVendorKYCDocuments`,
            formData,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
        );
    }
    SaveItemsDetail(requestInfo: IApiRequest<ISaveRequestWithFile>):
        Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        let formData = new FormData();
        for (let index = 0; index < requestInfo.requestInfo.documents.length; index++) {
            formData.append('documents', requestInfo.requestInfo.documents[index]);
        }
        formData.append('requestData', requestInfo.requestInfo.requestData);
        formData.append('content', requestInfo.requestInfo.content);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}SaveItemsDetail`,
            formData,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
        );
    }

    UpdateFormStatusDetails(
        requestInfo: IApiRequest<IFormsUpdateRequest>
    ): Observable<IApiresponse<ResponseVendorKYCDocuments>> {

        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}UpdateVendorKYCDocuments`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    DeleteCategoryItem(requestInfo: IApiRequest<DeleteCategoryItem>): Observable<IApiresponse<any>> {
        let formType = requestInfo.requestInfo.categoryItemId;
        return this.http.get<IApiresponse<any>>(
            `${environment.apAutomationUrl}DeleteCategoryItem?categoryItemId=${formType}`,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }


    GetKYCDocumentsForApproval(): Observable<IApiresponse<RespGetKYCDocumentsForApproval>> {
        return this.http.get<IApiresponse<RespGetKYCDocumentsForApproval>>(
            `${environment.apAutomationUrl}GetKYCDocumentsForApproval`,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetVendorDashboardDetails(requestInfo: IApiRequest<ReqGetVendorDashboard>): Observable<IApiresponse<GetVendorDashboardDetailsResponse>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<GetVendorDashboardDetailsResponse>>(
            `${environment.apAutomationUrl}GetVendorDashboardDetails`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetPendingInvoiceList(requestInfo: IApiRequest<ReqIncompleteClaimantList>):
        Observable<IApiresponse<RespIncompleteMileageList>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<RespIncompleteMileageList>>(
            `${environment.expenseApiUrl}GetPendingInvoiceList`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    GetVendorList(
        request: IApiRequest<GetVendorListRequest>
    ): Observable<VendorListResponse[]> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}GetVendorList`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    BulkAddUpdateVendor(
        addUpdatereq: IAddUpdateBulkVendorRequestDto
    ): Observable<any> {
        {
            let requestinfo = new ApiRequest<IAddUpdateBulkVendorRequestDto>(
                "BulkInviteVendor",
                1.0,
                "111"
            );
            requestinfo.requestInfo = addUpdatereq;
            let body = JSON.stringify(requestinfo);
            return this.http.post<IApiresponse<any>>(
                `${environment.apAutomationUrl}AddVendor`,
                body,
                { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
            );
        }
    }
    getVendorDetailsById(userId: number, orgId: number): Observable<any> {
        return this.http
            .get(`${environment.apAutomationUrl}GetVendorDetailsById?userId=${userId}&orgId=${orgId}`, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            })
    }
    getPoDisplaySettings(requestinfo: IApiRequest<GetPoDisplayRequest>): Observable<IApiresponse<PoDisplayResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<PoDisplayResponse>>(`${environment.apAutomationUrl}GetPoDisplaySettings`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    savePoDisplaySettings(requestinfo: IApiRequest<SavePoDisplayRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<PoDisplayResponse>>(`${environment.apAutomationUrl}SavePoDisplaySettings`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    getPoTemplateProperties(requestinfo: IApiRequest<GetPoTemplatePropertiesRequest>): Observable<IApiresponse<PoTemplatePropertiesResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<PoTemplatePropertiesResponse>>(`${environment.apAutomationUrl}GetPoTemplateProperties`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    savePoTemplateProperties(requestinfo: IApiRequest<SavePoTemplatePropertiesRequest>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<SavePoTemplatePropertiesRequest>>(`${environment.apAutomationUrl}SavePoTemplateProperties`, body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    UpdateRequisitionRuleTypeForOrganisation(requestinfo: IApiRequest<GetOrgPreferencesRequest>): Observable<IApiresponse<ITwoStepApprovalSaveResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<ITwoStepApprovalSaveResponse>>(`${environment.billingApiUrl}UpdateRequisitionRuleTypeForOrganisation`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }

    GetRequisitionUserList(requestinfo: IApiRequest<GetRequisitionUserListRequest>): Observable<IApiresponse<GetRequisitionUserListResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<GetRequisitionUserListResponse>>(`${environment.billingApiUrl}GetRequisitionUserList`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    UpdateForRequisition(requestinfo: IApiRequest<UpdateForRequisitionRequest>): Observable<IApiresponse<UpdateForRequisitionResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<UpdateForRequisitionResponse>>(`${environment.billingApiUrl}UpdateForRequisition`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    SaveUserKYCFormFieldDetail(requestinfo: IApiRequest<UserKYCFormFieldDetailRequest>): Observable<IApiresponse<UserKYCFormFieldDetailResponse>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<UserKYCFormFieldDetailResponse>>(`${environment.apAutomationUrl}SaveUserKYCFormFieldDetail`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    GetFormFieldDetail(requestinfo: IApiRequest<GetFormFieldDetailRequest>): Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(`${environment.apAutomationUrl}GetFormFieldDetail`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    GetItemGradeMappingList(requestinfo: IApiRequest<GetGradeMappingRequest>): Observable<IApiresponse<RespGetItemGradeMapping>> {
        let body = JSON.stringify(requestinfo);
        return this.http.post<IApiresponse<RespGetItemGradeMapping>>(`${environment.apAutomationUrl}GetItemGradeMapping`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    GetAllVendorGradesByOrgId(requestInfo: IApiRequest<IRequestGradeListAll>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IResponseGradeList>>(`${environment.apAutomationUrl}GetAllVendorGradesByOrgId`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    SaveCategoriesAndItemsData(requestInfo: IApiRequest<RequestSaveCategoriesAndItemsData>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(`${environment.apAutomationUrl}SaveCategoriesAndItemsData`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }
    ImportGradesForVendor(requestInfo: IApiRequest<RequestImportVendorGrades>): Observable<IApiresponse<IResponseGradeList>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<IResponseGradeList>>(`${environment.apAutomationUrl}ImportVendorGrades`, body, { headers: this.claimsHeaderService.createLoginAuthorizationHeader() });
    }

    GetGradeListForAssignEmployee(
        requestInfo: IApiRequest<IRequestGradeListForAssignEmployee>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.apAutomationUrl}VendorGetGradeListForAssignEmployee`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    CreateGrade(requestInfo: IApiRequest<IRequestGrade>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.apAutomationUrl}CreateVendorGrade`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }
    UpdateGrade(
        requestInfo: IApiRequest<IRequestGrade>): Observable<IApiresponse<any>> {
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<any>>(
            `${environment.apAutomationUrl}UpdateVendorGrade`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    exportData(
        exportedData: any[],
        excelFileName: string,
        addErrorColumn: boolean
    ) {
        let mappedData: IVendorGradeCsvRecordExport[] = [];
        for (let i = 0; i < exportedData.length; i++) {
            let recordExport = new VendorGradeCsvRecordExport();
            recordExport.GradeName = exportedData[i].gradeName;
            recordExport.Description = exportedData[i].gradeDescription;
            recordExport.EmployeeEmail = exportedData[i].EmployeeEmail;
            if (addErrorColumn) {
                recordExport.Error = exportedData[i].error;
            }

            mappedData.push(recordExport);
        }

        this.excelExportService.exportAsExcelFile(mappedData, excelFileName);
    }

    GetOrderData(
        requestInfo: IApiRequest<GetOrderListRequest>
    ): Observable<IApiresponse<RespGetOrderData>> {
        requestInfo.requestInfo.requisitionApprovalRuleType = this.claims.RequisitionApprovalRuleType;
        let body = JSON.stringify(requestInfo);
        return this.http.post<IApiresponse<RespGetOrderData>>(
            `${environment.apAutomationUrl}GetOrderData`,
            body,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
        );
    }

    GetCategoryList(
        request: IApiRequest<GetVendorListRequest>
    ): Observable<IApiresponse<GetCategoryListResponse>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}GetCategoryList`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    SaveUserGradeMapping(
        request: IApiRequest<GradeMappringResponse>
    ): Observable<IApiresponse<RespGradeAssignUnassignToItem>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}SaveUserGradeMapping`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    SaveOrderDetail(
        request: IApiRequest<SaveOrderDetailReq>
    ): Observable<IApiresponse<SaveOrderDetailResponse>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}SaveOrderDetail`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    SubmitApproverAction(
        request: IApiRequest<ApproveRejectRequisitionRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}SubmitApproverActionForRequisition`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    AddUpdatePOandMapping(
        request: IApiRequest<AddUpdatePOandMappingReq>
    ): Observable<IApiresponse<AddUpdatePOandMappingResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}AddUpdatePOandMapping`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetPOandMappingData(
        request: IApiRequest<GetPOandMappingDataReq>
    ): Observable<IApiresponse<GetPOandMappingDataResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<GetPOandMappingDataResp>>(`${environment.apAutomationUrl}GetPOandMappingData`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetPoPreviewData(
        request: IApiRequest<GetPoPreviewRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}GetPoPreviewData`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    SavePoReceiptData(requestInfo: IApiRequest<ISaveRequestWithFile>):
        Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        let formData = new FormData();
        for (let index = 0; index < requestInfo.requestInfo.documents.length; index++) {
            formData.append('documents', requestInfo.requestInfo.documents[index]);
        }
        formData.append('requestData', requestInfo.requestInfo.requestData);
        formData.append('content', requestInfo.requestInfo.content);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}SavePoReceiptData`,
            formData,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
        );
    }

    GeneratePdf(
        request: any //IApiRequest<PoExportRequest>
    ): Observable<any> {  // Expecting a Blob
        let body = JSON.stringify(request);
        return this.http.post<any>(
            `${environment.apAutomationUrl}GeneratePdf`,
            body,
            {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
                responseType: 'blob' as 'json', // Important:  Expect a Blob
                observe: 'response' as 'response',   // Important:  Get the full response
            }
        );
    }

    SaveItemBrands(
        request: IApiRequest<IGetAndSaveItemBrandsReqResp>
    ): Observable<IApiresponse<IGetAndSaveItemBrandsReqResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<IGetAndSaveItemBrandsReqResp>>(`${environment.apAutomationUrl}SaveItemBrands`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetItemBrands(
        request: IApiRequest<IGetAndSaveItemBrandsReqResp>
    ): Observable<IApiresponse<IGetAndSaveItemBrandsReqResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<IGetAndSaveItemBrandsReqResp>>(`${environment.apAutomationUrl}GetItemBrands`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    SaveItemGradeMapping(
        request: IApiRequest<SaveItemGradeMappingRequest>
    ): Observable<IApiresponse<RespGradeAssignUnassignToItem>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<RespGradeAssignUnassignToItem>>(`${environment.apAutomationUrl}SaveItemGradeMapping`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    getInvoiceData(
        request: IApiRequest<GetInvoiceDataReq>
    ): Observable<IApiresponse<GetInvoiceDataResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<GetInvoiceDataResp>>(`${environment.apAutomationUrl}GetInvoiceData`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    GetReportPODetails(
        request: IApiRequest<GetReportPODetailsReq>
    ): Observable<IApiresponse<GetReportPODetailsResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<GetReportPODetailsResp>>(`${environment.apAutomationUrl}GetReportPODetails`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    AddUpdateVendorInvoice(requestInfo: IApiRequest<ISaveRequestWithFile>):
        Observable<IApiresponse<ResponseVendorKYCDocuments>> {
        let formData = new FormData();
        for (let index = 0; index < requestInfo.requestInfo.documents.length; index++) {
            formData.append('documents', requestInfo.requestInfo.documents[index]);
        }
        formData.append('requestData', requestInfo.requestInfo.requestData);
        formData.append('content', requestInfo.requestInfo.content);
        return this.http.post<IApiresponse<ResponseVendorKYCDocuments>>(
            `${environment.apAutomationUrl}AddUpdateVendorInvoice`,
            formData,
            { headers: this.claimsHeaderService.createLoginAuthorizationHeaderWithoutContentTypeHeader() }
        );
    }

    GetVendorInvoiceList(
        request: IApiRequest<GetVendorInvoiceListReq>
    ): Observable<IApiresponse<GetVendorInvoiceListResp>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<GetVendorInvoiceListResp>>(`${environment.apAutomationUrl}GetVendorInvoiceList`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    ScanVendorInvoice(request): Observable<any> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<any>>(`${environment.apAutomationUrl}ScanVendorInvoice`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    SubmitInvoiceAction(
        request: IApiRequest<SubmitInvoiceActionRequest>
    ): Observable<IApiresponse<SubmitInvoiceActionResponse>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<SubmitInvoiceActionResponse>>(`${environment.apAutomationUrl}SubmitInvoiceAction`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetPoItemsPassbook(
        request: IApiRequest<GetPoItemsPassbookRequest>
    ): Observable<any> {
        let body = JSON.stringify(request);
        return this.http
            .post<any>(`${environment.apAutomationUrl}GetPoItemsPassbook`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    AddUpdateOrderAllocation(
        request: IApiRequest<AddUpdateOrderAllocationRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<any>>(`${environment.apAutomationUrl}AddUpdateOrderAllocation`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetOrderAllocationList(
        request: IApiRequest<GetItemOrderAllocationRequest>
    ): Observable<IApiresponse<any>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<any>>(`${environment.apAutomationUrl}GetOrderAllocationList`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }
    GetDashboardReportDetails(
        request: IApiRequest<GetDashboardReportRequest>
    ): Observable<IApiresponse<GetDashboardReportResponse>> {
        let body = JSON.stringify(request);
        return this.http
            .post<IApiresponse<GetDashboardReportResponse>>(`${environment.apAutomationUrl}GetDashboardReportDetails`, body, {
                headers: this.claimsHeaderService.createLoginAuthorizationHeader(),
            });
    }

    BulkDeactiveGrade(
    requestInfo: IApiRequest<IRequestGradeBulkDeactivate>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.apAutomationUrl}BulkDeactiveGrade`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }

    BulkReactiveGrade(
    requestInfo: IApiRequest<IRequestGradeBulkDeactivate>
  ): Observable<IApiresponse<any>> {
    let body = JSON.stringify(requestInfo);
    return this.http.post<IApiresponse<any>>(
      `${environment.apAutomationUrl}BulkReactiveGrade`,
      body,
      { headers: this.claimsHeaderService.createLoginAuthorizationHeader() }
    );
  }
}
